import React from 'react';
import './ManagementPage.css';

function ManagementPageEn() {
  return (
    <div className="page management-page">
      <section className="management-hero">
        <div className="management-hero-content">
          <h1>Management</h1>
        </div>
      </section>

      <section className="management-content">
        <div className="content-container">
          <div className="intro-text">
            <h2 className="intro-title">Comprehensive Real Estate Asset Management</h2>
            <p>
              TABIA Management is the TABIA Group company specialized in real estate asset management, 
              with the objective of creating, preserving and maximizing the value of our clients' real estate portfolios.
            </p>
            <p>
              We provide services to family groups, companies, investment funds —national and international—, 
              as well as industrial and service companies interested in structuring, developing and maintaining 
              real estate asset portfolios aligned with their strategic objectives.
            </p>
            <p>
              Our business model is based on a comprehensive and flexible approach, adapted to the specific needs 
              of each client, covering all phases of the real estate investment life cycle:
            </p>
          </div>

          <div className="services-list">
            <div className="service-item">
              <h3>Strategic Consulting</h3>
              <p>
                In defining the real estate portfolio, analyzing the type of assets, their composition 
                and diversification, sizes, risk and profitability levels, as well as their appropriate location.
              </p>
            </div>

            <div className="service-item">
              <h3>Identification and Execution of Opportunities</h3>
              <p>
                For investment and divestment, in accordance with the previously defined strategy and market 
                conditions at any given time.
              </p>
            </div>

            <div className="service-item">
              <h3>Continuous Support</h3>
              <p>
                In portfolio management, monitoring its evolution, optimizing its performance and adapting it 
                dynamically to changes in the economic environment and the real estate market.
              </p>
            </div>
          </div>

          <div className="closing-text">
            <p>
              Our extensive experience in the sector allows us to carry out an exhaustive strategic analysis of both 
              assets and markets, rigorously evaluating the risks associated with each 
              operation and developing risk management and mitigation strategies aimed at protecting 
              capital.
            </p>
            <p>
              TABIA has a highly qualified and multidisciplinary team, offering a range of specialized 
              professional services designed to complement real estate investment projects, 
              streamline decision-making processes and drive the growth and asset consolidation 
              of our clients.
            </p>
          </div>

          <div className="cards-section">
            <h2 className="cards-title">We develop the investment profile, defining</h2>
            <div className="cards-grid">
              <div className="card">
                <h3>Asset Typology</h3>
                <p>Detailed analysis of different types of real estate assets to optimize your investment portfolio.</p>
              </div>
            <div className="card">
              <h3>Tax and Financial Strategy</h3>
              <p>Comprehensive planning that optimizes the tax and financial structure of your real estate investments.</p>
            </div>
            <div className="card">
              <h3>Expected Profitability Structure</h3>
              <p>Clear definition of profitability objectives based on exhaustive market analysis and financial projections.</p>
            </div>
            <div className="card">
              <h3>Optimal Leverage Levels</h3>
              <p>Balanced financing strategies that maximize returns while minimizing financial risk.</p>
            </div>
            <div className="card">
              <h3>Asset Growth and Rotation Plan</h3>
              <p>Development of dynamic strategies for sustainable growth and efficient rotation of your assets.</p>
            </div>
          </div>
          </div>

          <div className="quote-with-bg-section" style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/gestion-quote-bg.png)`,
            backgroundSize: '80%',
            backgroundPosition: '-50px center',
            backgroundRepeat: 'no-repeat'
          }}>
            <div className="quote-bg-overlay"></div>
            <div className="quote-bg-content">
              <blockquote className="quote-bg-text">
                <p>
                  "At Tabia Group we conceive the real estate sector as a tool for long-term value creation: 
                  we identify opportunities, structure solid investments and manage assets with a strategic vision, 
                  professional and profitability-oriented."
                </p>
                <footer className="quote-bg-author">
                  — David Pons Camps, President of Tabia Group
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ManagementPageEn;
